<div class="card-icon-block" [ngClass]="[variant, size]">
  <img [src]="iconSrc" alt="" />
</div>
